export enum KeyCode {
  BACKSPACE = 8,
  DELETE = 46,
  ZERO = 48
}